<template>
  <div class="ResearchMethods">
    <div class="cont">
      <ComTitlte
        titleEn="RESEARCH METHODS"
        titleZh="业务范围及调查研究方法"
      ></ComTitlte>
      <div class="main">
        <p>
          业务范围几乎涵括所有的社情民意调研领域和部门专项统计调查领域，形成了一套成熟的、先进的、规范的以及高效的运作管理机制。
        </p>
        <p>
          根据不同项目的需求，研究设计采用多样化的调查方式，如：入户访问、计算机辅助电话调查（CATI系统）、街头拦截访问/定点访问、网络调查、深度访谈、专家访谈、焦点团体座谈会、产品测试、广告测试、网上调查、邮寄调查、二手资料搜集和分析、案例研究等，确保调查的科学性和有效性。
        </p>
        <img
          src="../../assets/img/company/c_img1.png"
          alt="业务范围及调查研究方法"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ComTitlte from "@/components/common/comTitle";
export default {
  name: "ResearchMethods",
  components: { ComTitlte },
};
</script>

<style lang="scss" scoped>
$themeColor: #406cdd;
$themeMinWidth: 1180px;
.cont {
  width: $themeMinWidth;
  margin: 0 auto;
  .main {
    width: 100%;
    padding: 40px 0 0 0;
    p {
      font-size: 16px;
      line-height: 30px;
      color: #666666;
      text-align: justify;
      text-indent: 32px;
    }
    img {
      display: block;
      width: 100%;
      padding: 20px 0 0 0;
    }
  }
}
</style>
